import { UPDATE_DURATION_IN_SCHEDULE } from "../constants/schedules";
import { Action, EditDurationInScheduleData } from "../models/edit-duration-schedule";

const initialState: EditDurationInScheduleData = {
  durationIsChanged: false,
};

const EditDurationInScheduleReducer = (
  state: EditDurationInScheduleData = initialState,
  action: Action
): EditDurationInScheduleData => {
  switch (action.type) {
    case UPDATE_DURATION_IN_SCHEDULE: {
      return {
        durationIsChanged: action.payload.durationIsChanged,
      };
    }
    default:
      return state;
  }
};

export default EditDurationInScheduleReducer;
